import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src="/logo.png" alt="Indapur FPC" className="w-14 h-14 object-contain bg-white/10 rounded-full p-1" />
            <div className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>
              INDAPUR FPC
            </div>
          </div>
          <p className="text-sm text-white/80 leading-relaxed">
            Working for farmers, growing with farmers. A farmer-led producer company committed to sustainable
            agriculture and prosperity.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={SITE.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
              data-testid="footer-whatsapp"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-white/70">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-accent transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-accent transition-colors">About Us</Link></li>
            <li><Link to="/products" className="hover:text-accent transition-colors">Products & Services</Link></li>
            <li><Link to="/activities" className="hover:text-accent transition-colors">Activities</Link></li>
            <li><Link to="/gallery" className="hover:text-accent transition-colors">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-accent transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-white/70">Contact Info</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{SITE.address}</span>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-0.5 shrink-0" />
              <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="hover:text-accent">{SITE.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 shrink-0" />
              <a href={`mailto:${SITE.email}`} className="hover:text-accent">{SITE.email}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-white/70">Stay Connected</h4>
          <p className="text-sm text-white/80 mb-4">
            For the latest updates, training programs and market prices.
          </p>
          <a
            href={SITE.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#25D366] hover:bg-[#1ebc59] transition-colors text-sm font-semibold"
            data-testid="footer-whatsapp-cta"
          >
            <MessageCircle className="w-4 h-4" />
            Chat on WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-white/60">
          <span>© {new Date().getFullYear()} Indapur Farmers Producer Company Limited. All rights reserved.</span>
          <span>Designed with care for the farming community.</span>
        </div>
      </div>
    </footer>
  );
}
